export default __webpack_public_path__ + "static/media/bg2.bf3d3de5.jpg";